import React, { PropTypes } from 'react';

const BAMIFrame = ({ id, src }) => {
    const content = src && <iframe src={src} />;
    return (
        <div id={id}>
            {content}
        </div>
    );
};

BAMIFrame.propTypes = {
    id: PropTypes.string,
    src: PropTypes.string
};

export default BAMIFrame;



// WEBPACK FOOTER //
// ./app/webapp/common/BAMIFrame.js